import {of as observableOf, Observable} from 'rxjs';

import {shareReplay, distinctUntilChanged} from 'rxjs/operators';
import {DetailTabconfig} from './detail-tabconfig';

export class ViewConfig {
  _Details: Observable<DetailTabconfig[]>;
  HasSummary: boolean = false;
  _DisplayName: Observable<string> = observableOf('');
  _ObjectType: string;
  _SummaryFilteredAttributes: Observable<string[]> = observableOf([]);

  constructor() {
    this._Details = observableOf([]);
  }

  get Details(): Observable<DetailTabconfig[]> {
    return this._Details;
  }

  setDetails(dtcs: Observable<DetailTabconfig[]>) {
    let details = dtcs.pipe(distinctUntilChanged(), shareReplay(1));
    details.subscribe();
    this._Details = details;
  }

  get DisplayName(): Observable<string> {
    return this._DisplayName;
  }

  setDisplayName(displayname: Observable<string>) {
    this._DisplayName = displayname.pipe(distinctUntilChanged(), shareReplay(1));
  }

  get ObjectType(): string {
    return this._ObjectType;
  }

  setObjectType(objectType: string) {
    this._ObjectType = objectType;
  }

  get SummaryFilteredAttributes(): Observable<string[]> {
    return this._SummaryFilteredAttributes;
  }

  setSummaryFilteredAttributes(summaryFilteredAttributes: Observable<string[]>) {
    this._SummaryFilteredAttributes = summaryFilteredAttributes.pipe(
      distinctUntilChanged(),
      shareReplay(1),
    );
  }

  destroy() {
    this._Details;
  }
}
